const mapToEventsWithValues = events =>
  events
    .map(event => {
      if (typeof event === "string") {
        return event;
      }
      const [key, value] = Object.entries(event)[0];

      return `${key}=${value}`;
    })
    .join(",");

export default mapToEventsWithValues;
